import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ServiceResponse } from 'src/app/models/service-response';
import { VisitService } from 'src/app/rest_services/visit.service';
import { Chart, registerables } from 'chart.js';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { CustomersService } from 'src/app/rest_services/customers.service';
import { SectorService } from 'src/app/rest_services/sector.service';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
import * as am4plugins_sliceGrouper from "@amcharts/amcharts4/plugins/sliceGrouper"; 

import am4geodata_worldMoroccoLow from "@amcharts/amcharts4-geodata/worldMoroccoLow";

import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CityService } from 'src/app/rest_services/city.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
am4core.useTheme(am4themes_animated);
Chart.register(...registerables);

@Component({
  selector: 'app-statistics-customers',
  templateUrl: './statistics-customers.component.html',
  styleUrls: ['./statistics-customers.component.css']
})
export class StatisticsCustomersComponent implements OnInit {
  mobile:boolean=false;
  loadingVisitStatistics:boolean = true;
  visitStatistics:Array<any> = [];
  visitStatisticsSubscription!: Subscription;

  loadingActionsStatistics:boolean = true;
  actionsStatistics:Array<any> = [];
  actionsStatisticsSubscription!: Subscription;

  
  loadingClientssStatistics:boolean = true;
  clientsStatistics:Array<any> = [];
  clientsStatisticsSubscription!: Subscription;

  loadingSectorsIndicators:boolean = true;
  sectorsIndicators:Array<any> = [];
  sectorsIndicatorsSubscription!: Subscription;
  
  citiesPresenceCustomersSubscription!: Subscription;

  constructor(private visitService: VisitService,
              private actionService: NewactionService,
              private customersService:CustomersService,
              private msSector:MsSectorService,
              private sectorService : SectorService,
              private cityService : CityService) { }
  currentYear:number=0;
  connectedCompany:any="";
  ngAfterViewInit(){
    this.getCustomersMaps();
  }
  token:any = '';
  ngOnInit(): void {
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    this.currentYear = new Date().getFullYear();
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
    if(localStorage.getItem("comp")!=undefined){
      this.connectedCompany = localStorage.getItem("comp")?.toString();
    }else {
      this.connectedCompany = sessionStorage.getItem("comp")?.toString();
    }
    this.getSectorsIndicators();
    // this.getCustomersMaps();
  }
  getRandomColorHex() {
    var hex = "0123456789ABCDEF",
        color = "#";
    for (var i = 1; i <= 6; i++) {
      color += hex[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  ngOnDestroy() {
    this.visitStatisticsSubscription?.unsubscribe();
    this.actionsStatisticsSubscription?.unsubscribe();
    this.clientsStatisticsSubscription?.unsubscribe();
    this.sectorsIndicatorsSubscription?.unsubscribe();
  }

  indicators:any[]=[];
  withoutCustomers:any[]=[];
  noIndicatorsSectorsExist:boolean=false;
  getSectorsIndicators(){
    this.loadingSectorsIndicators = true;
    this.sectorsIndicatorsSubscription = this.sectorService.getSectorsIndicators().subscribe(
      (res: any) => {
        if(res.code == "1125d1fec84b71594c2f9786a8820f28"){
          this.indicators = res.sectorIndicator;     
          console.log(this.indicators);
          
         // this.withoutCustomers = res.sectorsWithoutCustomers;     
          const labels = [];
          const values = [];
          for (const iterator of this.indicators) {
            this.msSector.getSector(this.token, iterator.sector).subscribe(
              (sectorLabel: any) => {
                iterator.sector = sectorLabel.label;
              },
              (error) => {
                console.log(error);
              }
            );
          }
         setTimeout(() => {
            for (const iterator of this.indicators) {
              labels.push(iterator.sector);
              values.push(iterator.countCustomers);
            }
          let chart = am4core.create("myChart_sectors", am4charts.PieChart3D);
          chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
          // chart.legend.labels.template.fill = am4core.color("#f00");
          // chart.legend.valueLabels.template.fill = am4core.color("#f00"); 
          chart.legend = new am4charts.Legend();
          chart.responsive.enabled = true;
          if(this.mobile){
            chart.responsive.rules.push({
              relevant: function(target) {
                if (target.pixelWidth <= 800) {
                  return true;
                }
                return false;
              },
              state: function(target:any, stateId:any) :any{
                if (target instanceof am4charts.Chart) {
                  var state = target.states.create(stateId);
                  state.properties.paddingTop = 0;
                  state.properties.paddingRight = 25;
                  state.properties.paddingBottom = 0;
                  state.properties.paddingLeft = 25;
                  return state;
                } else if (target instanceof am4charts.AxisLabelCircular ||
                  target instanceof am4charts.PieTick) {
                  var stat = target.states.create(stateId);
                  stat.properties.disabled = true;
                  return stat;
                }
                return null;
              }
            });
          }
          chart.data = res.sectorIndicator;
          chart.legend.position = "top";
          chart.legend.maxHeight = 150;
          chart.legend.maxWidth = 300;
          chart.legend.scrollable = true;
          chart.innerRadius = 80;
          chart.legend.labels.template.text = "{sector}: [bold {color}]({countCustomers})[/]";
          
          
          let series = chart.series.push(new am4charts.PieSeries3D());
          series.labels.template.text = "[bold]--- [/]{category}";
          series.labels.template.fontSize= "13px"; 
          series.labels.template.text = series.labels.template.text + " : [bold]({value})[/]";
          series.dataFields.value = "countCustomers";
          series.dataFields.category = "sector";
          series.labels.template.maxWidth = 280;
          series.labels.template.wrap = true;
          //series.labels.template.paddingTop = 0;
          //series.labels.template.paddingBottom = 0;
          series.labels.template.padding(1, 1, 1, 1);

          var grouper = series.plugins.push(new am4plugins_sliceGrouper.SliceGrouper());
          grouper.threshold = 5;
          grouper.groupName = "Other";
          grouper.clickBehavior = "zoom";
          setTimeout(()=>{
            var legends = document.querySelector('g[aria-labelledby="id-66-title"]');
            legends?.setAttribute("style","display:none !important;")
          }, 300);
         }, 1000);
        }else {
          this.noIndicatorsSectorsExist = true;
        }
        this.loadingSectorsIndicators = false;
      },
      (err: any) => {
        console.log(err);
        this.loadingSectorsIndicators = false;
      }
    );
  }
  loadingCustomersMaps:boolean=true;
  getCustomersMaps() {
    this.citiesPresenceCustomersSubscription = this.cityService.getPresentCitiesCustomers().subscribe(
      (res: any) => {
        if(res.code == "13d4895518c85b84c8e6940b6c4772e9"){
          this.loadingCustomersMaps = false;
          var listCities:any[] = [];
          
          for(let city of res.cities){
            city.percentage = city.percentage.toFixed(1);
            city.latitude = Number.parseFloat(city.latitude);
            city.longitude = Number.parseFloat(city.longitude);
            var cit = {
              customers:city.countCustomers,
              city:city.city,
              value:Number(city.percentage)
            }
            listCities.push(cit);
          }
          listCities = listCities.sort((a, b) => a.value < b.value ? 1 : -1);
          setTimeout(()=>{
          var chart = am4core.create("maps_customers", am4charts.PieChart);
          chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

          chart.data = listCities;
          chart.radius = am4core.percent(70);
          chart.innerRadius = am4core.percent(40);
          chart.startAngle = 180;
          chart.endAngle = 360;  
          
         

          var series = chart.series.push(new am4charts.PieSeries());
          series.dataFields.value = "value";
          series.dataFields.category = "city";
          series.labels.template.fontSize= "10px";
         
          // series.labels.template.text = "[bold][/]{category}";
          // series.labels.template.text = series.labels.template.text + " : [bold]({customers} Clients)[/]";
          
          series.slices.template.cornerRadius = 10;
          series.slices.template.innerCornerRadius = 7;
          series.slices.template.draggable = true;
          series.slices.template.inert = true;
          series.alignLabels = false;
          series.colors.list = [
            am4core.color("#2a4858"),
            am4core.color("#294d5d"),
            am4core.color("#275163"),
            am4core.color("#255667"),
            am4core.color("#225b6c"),
            am4core.color("#0e6f7d"),
            am4core.color("#1ea78f"),
            am4core.color("#32b18e"),
            am4core.color("#3cb68d"),
            am4core.color("#6ecd85"),
            am4core.color("#8eda7f"),
            am4core.color("#a5e27a"),
            am4core.color("#99de7c"),
            am4core.color("#bcea75"),
            am4core.color("#c8ed73"),
            am4core.color("#d4f171"),
            am4core.color("#e0f470"),
            am4core.color("#fafa6e")
        ];
          series.hiddenState.properties.startAngle = 90;
          series.hiddenState.properties.endAngle = 90;
          var grouper = series.plugins.push(new am4plugins_sliceGrouper.SliceGrouper());
          grouper.threshold = 5;
          grouper.groupName = "Autres";
          grouper.clickBehavior = "zoom";
          chart.legend = new am4charts.Legend();
          // chart.legend.maxHeight = 100;
          chart.legend.background.fill = am4core.color("#000");
          chart.legend.background.fillOpacity = 0.05;
          chart.legend.position = "top";
          chart.legend.maxHeight = 100;
          chart.legend.scrollable = true;
          chart.legend.labels.template.text = "{city}: [bold]({customers} Clients)[/]";
          chart.legend.fontSize = "10px";
          chart.legend.scrollable = true;
        }, 1000);
          // setTimeout(()=>{
          //   // Create map instance
          //   var chart = am4core.create("maps_customers", am4maps.MapChart);
          //   chart.geodata = am4geodata_worldMoroccoLow;
          //   chart.projection = new am4maps.projections.Miller();

          //   // Colors
          //   var color1 = chart.colors.getIndex(18);

          //   chart.homeGeoPoint = {
          //     latitude: 32,
          //     longitude: -7
          //   }
          //   chart.homeZoomLevel = 23;
          //   chart.minZoomLevel = 6;
          //   chart.maxZoomLevel = 100;

          //   // Create map polygon series
          //   var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
          //   polygonSeries.exclude = ["antarctica"];
          //   polygonSeries.useGeodata = true;

          //   // Configure series
          //   var polygonTemplate = polygonSeries.mapPolygons.template;
          //   polygonTemplate.fill = am4core.color("#d1fee5");

          //   // Add shadow
          //   var shadow = polygonSeries.filters.push(new am4core.DropShadowFilter());
          //   shadow.color = am4core.color("#fff");
          //   shadow.blur = 0;

          //   // Pins
          //   var imageSeries = chart.series.push(new am4maps.MapImageSeries());
          //   var imageTemplate = imageSeries.mapImages.template;
          //   imageTemplate.propertyFields.longitude = "longitude";
          //   imageTemplate.propertyFields.latitude = "latitude";
          //   imageTemplate.nonScaling = true;

          //   // Creating a pin bullet
          //   var pin = imageTemplate.createChild(am4plugins_bullets.PinBullet);
          //   chart.seriesContainer.zIndex = 10;
          //   chart.fontSize = 15;
          //   // Configuring pin appearance
          //   pin.background.fill = color1;
          //   pin.background.strokeWidth = 1;
          //   pin.background.stroke = am4core.color("#02895d");
          //   pin.background.pointerBaseWidth = 1;
          //   pin.background.pointerLength = 250;
          //   pin.background.propertyFields.pointerLength = "length";
          //   pin.circle.fill = pin.background.fill;
          //   pin.properties.scale = 1;
          //   pin.label = new am4core.Label();
          //   pin.label.text = "{percentage}%";
          //   pin.label.wrap = true;
          //   pin.label.tooltipText = "{city}"+ " ("+ "{countCustomers}"+" Clients)";
          //   pin.label.fill = am4core.color("title");

          //   // Pin data
          //   imageSeries.data = res.cities;

          //   // LABEL SHOWED SIDE OF PINS
          //   // var label = pin.createChild(am4core.Label);
          //   // label.text = "{city}";
          //   // label.fontWeight = "bold";
          //   // label.propertyFields.dy = "length";
          //   // label.propertyFields.dx = "length";
          //   // label.verticalCenter = "top";
          //   // label.fill = am4core.color("#00000");
          //   // label.adapter.add("dy", function(dy:any) {
          //   //   return (-3 + dy) * -1;
          //   // });
          //   // label.adapter.add("dx", function(dx:any) {
          //   //   return (5 + dx) * -1;
          //   // });

          //   // Creating a "heat rule" to modify "radius" of the bullet based
          //   // on value in data
          //   imageSeries.heatRules.push({
          //     "target": pin.background,
          //     "property": "radius",
          //     "min": 20,
          //     "max": 30,
          //     "dataField": "value"
          //   });          
          // }, 1000);
        }
      }
    );

  }
}
